import React, { useState } from "react";
import { Link, useSearchParams, useNavigate } from "react-router-dom";
import { AuthShell } from "./AuthShell";
import { api, getErrorMessage } from "@/lib/api";
import { Loader2 } from "lucide-react";
import { toast } from "sonner";

export default function ResetPassword() {
    const [params] = useSearchParams();
    const navigate = useNavigate();
    const token = params.get("token") || "";
    const [password, setPassword] = useState("");
    const [confirm, setConfirm] = useState("");
    const [loading, setLoading] = useState(false);
    const [error, setError] = useState("");

    const onSubmit = async (e) => {
        e.preventDefault();
        if (password !== confirm) { setError("Passwords don't match"); return; }
        setError(""); setLoading(true);
        try {
            await api.post("/auth/reset-password", { token, password });
            toast.success("Password updated");
            navigate("/login", { replace: true });
        } catch (err) {
            setError(getErrorMessage(err));
        } finally { setLoading(false); }
    };

    return (
        <AuthShell title="Set a new password." subtitle="Choose something strong but memorable.">
            {!token ? (
                <p className="text-[14px] text-coral">Invalid or missing token. <Link to="/forgot-password" className="underline">Request a new link →</Link></p>
            ) : (
                <form onSubmit={onSubmit} data-testid="reset-form" className="space-y-4">
                    <div>
                        <label className="block text-[12px] font-semibold text-ink mb-1.5">New password</label>
                        <input type="password" required minLength={6} value={password} onChange={(e) => setPassword(e.target.value)}
                            data-testid="reset-password" placeholder="At least 6 characters"
                            className="w-full bg-white border border-cream-300 rounded-2xl px-4 py-3 text-[15px] focus:outline-none focus:ring-2 focus:ring-coral/40 focus:border-coral transition"/>
                    </div>
                    <div>
                        <label className="block text-[12px] font-semibold text-ink mb-1.5">Confirm</label>
                        <input type="password" required minLength={6} value={confirm} onChange={(e) => setConfirm(e.target.value)}
                            data-testid="reset-confirm" placeholder="Repeat password"
                            className="w-full bg-white border border-cream-300 rounded-2xl px-4 py-3 text-[15px] focus:outline-none focus:ring-2 focus:ring-coral/40 focus:border-coral transition"/>
                    </div>
                    {error && <p className="text-[13px] text-coral font-medium">{error}</p>}
                    <button
                        type="submit" disabled={loading} data-testid="reset-submit"
                        className="w-full bg-ink hover:bg-coral text-cream-100 rounded-full py-3.5 text-[14.5px] font-semibold inline-flex items-center justify-center gap-2 transition-all disabled:opacity-70"
                    >
                        {loading ? <><Loader2 size={16} className="animate-spin"/> Updating…</> : <>Update password →</>}
                    </button>
                </form>
            )}
        </AuthShell>
    );
}
